// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";

function ThreeDSRedirectionModal(props) {
  let match = React.useState(() => "");
  let setPopupUrl = match[1];
  let match$1 = React.useState(() => "");
  let setRedirectResponseUrl = match$1[1];
  let redirectResponseUrl = match$1[0];
  let match$2 = React.useState(() => false);
  let match$3 = React.useState(() => false);
  let setloader = match$3[1];
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let eventsToSendToParent = ["openurl_if_required"];
  UtilityHooks$OrcaPaymentPage.useSendEventsToParent(eventsToSendToParent);
  let handleOnClose = () => {
    if (redirectResponseUrl === "") {
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "fullscreen",
          false
        ]]);
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong.");
    }
    let customEvent = Utils$OrcaPaymentPage.getDictFromJson({
      openurl_if_required: redirectResponseUrl
    });
    Utils$OrcaPaymentPage.messageParentWindow(undefined, Object.entries(customEvent));
  };
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    setloader(param => true);
    let handle = ev => {
      try {
        let json = Utils$OrcaPaymentPage.safeParse(ev.data);
        let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
          return;
        }
        let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
        let metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
        let popupUrl = Utils$OrcaPaymentPage.getString(metaDataDict, "popupUrl", "");
        let redirectResponseUrl = Utils$OrcaPaymentPage.getString(metaDataDict, "redirectResponseUrl", "");
        setPopupUrl(param => popupUrl);
        setRedirectResponseUrl(param => redirectResponseUrl);
        return setloader(param => false);
      } catch (raw_err) {
        let err = Primitive_exceptions.internalToException(raw_err);
        let exceptionMessage = JSON.stringify(Utils$OrcaPaymentPage.formatException(err));
        loggerState.setLogError(exceptionMessage, "THREE_DS_POPUP_REDIRECTION", undefined, undefined, undefined, undefined, undefined);
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong.");
      }
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  return JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("iframe", {
        className: "w-full h-full",
        src: match[0]
      }),
      className: "w-full h-[500px] bg-white"
    }),
    closeCallback: handleOnClose,
    loader: match$3[0],
    setOpenModal: match$2[1],
    openModal: match$2[0]
  });
}

let make = ThreeDSRedirectionModal;

export {
  make,
}
/* jotai Not a pure module */
